export const roles = {
  owner_admin: "Owner / Admin",
  office_planner: "Office / Planner",
  operator: "Shop-floor Operator",
};
